import React from 'react';
import { FrownIcon, FileQuestionIcon, FlameIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const pains = [{
  icon: FrownIcon,
  text: 'Pasas semanas intentando clarificar tu oferta sin llegar a ningún lado.'
}, {
  icon: FileQuestionIcon,
  text: 'Sufres frente a una página en blanco tratando de escribir copy que venda.'
}, {
  icon: FlameIcon,
  text: 'Y cuando tienes algo, no sabes hacer anuncios que no quemen tu dinero.'
}];
export function PainSection() {
  return <section className="w-full bg-black py-12 sm:py-24" data-id="element-116">
      <div className="mx-auto max-w-4xl px-4" data-id="element-117">
        <Reveal data-id="element-118">
          <h2 className="text-center font-display text-2xl leading-tight text-white sm:text-4xl" data-id="element-119">
            ¿Sientes que estás atrapado en la{' '}
            <span className="text-orange-500" data-id="element-120">Parálisis por Análisis</span>?
          </h2>
        </Reveal>

        <div className="mt-8 grid gap-4 sm:mt-12 sm:grid-cols-3" data-id="element-121">
          {pains.map(({
          icon: Icon,
          text
        }, i) => <Reveal key={i} delay={i * 0.08} data-id="element-122">
              <div className="h-full rounded-2xl border border-zinc-800 bg-zinc-900/60 p-6" data-id="element-123">
                <Icon className="h-8 w-8 text-orange-500/80" aria-hidden="true" data-id="element-124" />
                <p className="mt-4 text-sm leading-relaxed text-zinc-300" data-id="element-125">
                  {text}
                </p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-126">
          <div className="mt-10 rounded-2xl border-l-4 border-red-500 bg-red-500/5 p-6 sm:p-8" data-id="element-127">
            <p className="text-sm font-bold uppercase tracking-wide text-red-400" data-id="element-128">
              El problema real
            </p>
            <p className="mt-3 text-lg leading-relaxed text-zinc-200 sm:text-xl" data-id="element-129">
              El marketing digital cambió. El contenido genérico ya no vende.{' '}
              <span className="font-bold text-white" data-id="element-130">
                La velocidad lo es todo.
              </span>{' '}
              Si tardas 3 meses en lanzar, tu idea ya expiró.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}